import { call, put, takeEvery, select } from "redux-saga/effects";

import { loaderUserSalaryConditions, setUserSalaryConditions } from "./actions";
import { userGetProfile } from "../user/actions";
import { ADD_USER_SALARY_CONDITIONS, DELETE_USER_SALARY_CONDITIONS, GET_USER_SALARY_CONDITIONS, UPDATE_USER_SALARY_CONDITIONS } from "./actionTypes";
import { getErrorMessage, showErrorMessage, showSuccessMessage } from "../../helpers/utils";
import { addUserSalaryConditionApi, deleteUserSalaryConditionApi, getUserSalaryConditionApi, patchUserSalaryConditionApi } from "../../helpers/jwt_helper";


function* onGetUserSalaryConditions({ payload: data }) {
  try {
    yield put(loaderUserSalaryConditions());
    let response = yield call(getUserSalaryConditionApi, {
      ...data,
    });

    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          created_at: new Date(i.created_at).toDateString(),
        })),
      };
    } else {
      response = {
        results: response,
      };
    }

    yield put(setUserSalaryConditions(response));
    yield put(loaderUserSalaryConditions());
  } catch (error) {
    yield put(loaderUserSalaryConditions());
  }
}

function* onAddUserSalaryConditions({ payload: { user_id, data } }) {
  try {

    yield put(loaderUserSalaryConditions());
    yield call(addUserSalaryConditionApi, data);
    showSuccessMessage(
      `Salary Condition has been added successfully`
    );
    yield put(userGetProfile(user_id))
    // yield call(onGetUserSalaryConditions, {
    //   payload: yield select(state => state.UserSalaryConditions.data),
    // });
    yield put(loaderUserSalaryConditions());
  } catch (e) {
    yield put(loaderUserSalaryConditions());
    getErrorMessage(showErrorMessage(e));
  }
}

function* onDeleteUserSalaryConditions({ payload: { user_id, id } }) {
  try {
    yield put(loaderUserSalaryConditions());
    yield call(deleteUserSalaryConditionApi, id);
    yield put(userGetProfile(user_id))
    // yield call(onGetUserSalaryConditions, {
    //   payload: yield select(state => state.UserSalaryConditions.data),
    // });
    yield put(loaderUserSalaryConditions());
    showSuccessMessage(`Salary condition has been deleted successfully`);
  } catch (error) {
    yield put(loaderUserSalaryConditions());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onUpdateUserSalaryConditions({ payload: { user_id, id, data } }) {
  try {
    yield put(loaderUserSalaryConditions());
    yield call(patchUserSalaryConditionApi, id, data);
    yield put(userGetProfile(user_id))
    // yield call(onGetUserSalaryConditions, {
    //   payload: yield select(state => state.UserSalaryConditions.data),
    // });
    yield put(loaderUserSalaryConditions());
    showSuccessMessage(`Updating salary condition has been successfully`);
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(loaderUserSalaryConditions());
  }
}

function* userSalaryConditionsSaga() {
  yield takeEvery(GET_USER_SALARY_CONDITIONS, onGetUserSalaryConditions);
  yield takeEvery(ADD_USER_SALARY_CONDITIONS, onAddUserSalaryConditions);
  yield takeEvery(DELETE_USER_SALARY_CONDITIONS, onDeleteUserSalaryConditions);
  yield takeEvery(UPDATE_USER_SALARY_CONDITIONS, onUpdateUserSalaryConditions);
}

export default userSalaryConditionsSaga;